"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Radio = void 0;
var react_1 = __importDefault(require("react"));
var clsx_1 = __importDefault(require("clsx"));
var hooks_1 = require("../../../../mantine-hooks/src");
var theme_1 = require("../../../../mantine-theme/src");
var Radio_styles_1 = __importDefault(require("./Radio.styles"));
function Radio(_a) {
    var _b;
    var className = _a.className, themeOverride = _a.themeOverride, id = _a.id, children = _a.children, style = _a.style, size = _a.size, elementRef = _a.elementRef, title = _a.title, disabled = _a.disabled, color = _a.color, others = __rest(_a, ["className", "themeOverride", "id", "children", "style", "size", "elementRef", "title", "disabled", "color"]);
    var classes = Radio_styles_1.default({ color: color, size: size, theme: theme_1.useMantineTheme(themeOverride) });
    var uuid = hooks_1.useId(id);
    return (react_1.default.createElement("div", { "data-mantine-radio": true, className: clsx_1.default(classes.wrapper, className), style: style, title: title },
        react_1.default.createElement("label", { className: clsx_1.default(classes.label, (_b = {}, _b[classes.labelDisabled] = disabled, _b)), htmlFor: uuid },
            react_1.default.createElement("input", __assign({ ref: elementRef, className: classes.radio, type: "radio", id: uuid, disabled: disabled }, others)),
            react_1.default.createElement("span", null, children))));
}
exports.Radio = Radio;
Radio.displayName = '@mantine/core/Radio';
